import React from 'react';
import { useParams } from 'react-router-dom';
import { useClientRecord, ClientFrame } from './ClientLayout';
import { fullName, primaryContactOf } from './clientShared';
import ParticipantEmail from '../Mail/ParticipantEmail';

// A client's Email tab: mail with them, their nominee or a contact on file, kept as a record.
export default function ClientEmail() {
  const { id } = useParams();
  const record = useClientRecord(id);
  const c = record && record.client;
  const name = c ? fullName(c) : '';
  const contact = c ? primaryContactOf(c) : null;
  const to = [c && c.nominee_email ? { name: c.nominee_name || '', address: c.nominee_email } : null,
    contact && contact.email ? { name: contact.name || [contact.first_name, contact.last_name].filter(Boolean).join(' '), address: contact.email } : null].filter(Boolean);
  return (
    <ClientFrame record={record}>
      {c && <ParticipantEmail clientId={c.id} name={name} to={to} />}
    </ClientFrame>
  );
}
